import { Column, PrimaryColumn } from "typeorm";
import { TenantIdSchemaBase } from "../interfaces/tenantId.base";

export class IplexGRegisteredSchema implements TenantIdSchemaBase  {
  @PrimaryColumn()
    serialNo: string;

  @Column({ nullable: true })
    token: string | null;

  @Column({ nullable: true })
    tenantId: string | null;

  @Column({ nullable: true })
    registeredBy: string | null;

  @Column()
    isValid: boolean;

  @Column({ nullable: true })
    isDeleted: boolean | null;
}
